import React from 'react'
import {lerp, register} from '../utils'
import {Group, Line} from 'react-konva'
import {getState} from '../game-surface'
import texture from './texture.png'
import useImage from 'use-image'
import {explode, explosionSound} from '../explosion'
import {useSpring} from 'react-spring'
import {showScore} from '../score'
import {handle, useEvent} from '../events'
import {playSound} from '../sound'

function returnTrue(props) {
    props.ok = true
}

function returnFalse(props) {
    props.ok = false
}

export const part = register('part', {
    postInitialize() {
        this.defaultSprite = this.$.transform.Sprite
        this.$.targetted = 0
        this.$.setState('in_place')
        handle('resetGame', () => {
            this.$.setState('in_place')
        })
    },
    methods: {
        Part,
        Update(dt) {
            this.$.targetted -= dt * 1000
        }
    },
    states: {
        in_place: {
            enter() {
                this.$.transform.Sprite = this.defaultSprite
                this.$.visible = true
                this.$.movement.rotation = 0
                this.$.movement.y = 0
                this.$.x = this.$.mountPoint.x
                this.$.y = this.$.mountPoint.y
            },
            methods: {
                canHit: returnTrue,
            },
        },
        falling: {
            enter() {
                this.$.targetted = this.targetted = 0
                this.$.movement.y = 1000 + Math.random() * 400
                this.$.movement.rotation = 80 + Math.random() * 100
                this.t = 0
            },
            methods: {
                canHit: returnFalse,
                update(dt) {
                    this.$.movement.y *= 1 + dt * 2
                    this.t += dt
                    if (this.t > 1) this.$.setState('waiting')
                },
            },
        },
        falling_part: {
            enter() {
                this.$.movement.y = 1000 + Math.random() * 400
                this.$.movement.rotation = 80 + Math.random() * 100
                this.t = 0
                explode(this.$.position())
            },
            methods: {
                canHit: returnFalse,
                update(dt) {
                    this.$.movement.y *= 1 + dt * 2
                    this.t += dt
                    if (this.t > 1) this.$.setState('waiting')
                },
            },
        },
        user_part: {
            enter() {
                this.timeIn = 0
                this.$.transform.Sprite = this.Part
                this.$.visible = true
                this.$.opacity = 1
                let q =
                    Math.abs(this.$.mountPoint.x) +
                    Math.abs(this.$.mountPoint.y) +
                    Math.abs(this.$.transform.width - this.$.shapeWidth) * 2 +
                    Math.abs(this.$.transform.height - this.$.shapeHeight) * 2
                this.quality = Math.floor(q / 20)
                console.log(this.quality)
                let factor = (this.$.factor = Math.max(0, this.quality - 3))
                let score = Math.floor(
                    Math.max(0, 10000 - (1 - Math.max(0, 1 - q / 900)) * 10000)
                )
                getState().score += score
                if (score) {
                    showScore(`+ ${score}`, this.$.position())
                }
                this.t = 30000 - (29000 * this.quality) / 40
                if (factor === 0) this.t = 1000 * 60 * 10
            },
            methods: {
                canHit: returnTrue,
                update(dt) {
                    this.timeIn += dt
                    this.t -= dt * 1000
                    if (this.t < 0) {
                        playSound(explosionSound)
                        this.$.setState('falling_part')
                    }
                },
            },
        },
        waiting: {
            enter() {
                this.$.visible = false
                this.$.movement.rotation = 0
                this.$.rotation = 0
                this.$.movement.y = 0
                this.$.x = this.$.mountPoint.x
                this.$.y = this.$.mountPoint.y
            },
            methods: {
                canTake: returnTrue,
                canHit: returnFalse,
                take(points, offset) {
                    let scale = getState().rocket.scale
                    this.$.mountOffset = offset
                    let minX = Infinity,
                        minY = Infinity,
                        maxX = -Infinity,
                        maxY = -Infinity
                    for (let i = 0; i < points.length; i += 2) {
                        if (points[i] < minX) minX = points[i]
                        if (points[i] > maxX) maxX = points[i]
                        if (points[i + 1] < minY) minY = points[i + 1]
                        if (points[i + 1] > maxY) maxY = points[i + 1]
                    }
                    this.$.shapeWidth = maxX - minX
                    this.$.shapeHeight = maxY - minY
                    this.$.special = points.map((p) => (p * 1) / scale)
                    this.$.setState('user_part')
                },
            },
        },
    },
})

function Part() {
    useEvent('resetGame', () => {
        this.$.setState('in_place')
    })
    const [image] = useImage(texture)
    const movement = useSpring({
        rotate: this.timeIn < 1 ? 0 : -60 + Math.random() * 60,
    })
    return (
        <Group
            x={-this.$.mountOffset.x}
            y={-this.$.mountOffset.y}
            opacity={1}
            rotation={lerp(movement.rotate.getValue(), 0, this.t / 30000)}
        >
            {image && (
                <Line
                    opacity={1}
                    points={this.$.special}
                    closed={true}
                    tension={0.3}
                    fillPatternImage={image}
                    fillPatternRepeat="no-repeat"
                    fillPatternOffsetY={image.width / 2}
                    fillPatternOffsetX={image.height / 2}
                    fillPatternScaleX={(this.$.shapeWidth * 2) / image.width}
                    fillPatternScaleY={(this.$.shapeHeight * 2) / image.height}
                    stroke="rgb(75,33,22)"
                    strokeWidth={1}
                />
            )}
        </Group>
    )
}
